import React from 'react'

export const companyLogo1 = [
    'https://assets.learntube.ai/files/AI_Syllabus_generator/Facebook_-_png_0__1_.png?updatedAt=1685624352896',
    'https://assets.learntube.ai/files/AI_Syllabus_generator/Amazon_-_jpeg_0.png?updatedAt=1685624249275',
    'https://assets.learntube.ai/files/AI_Syllabus_generator/Apple_-_png_0__1_.png?updatedAt=1685624249085',
    'https://assets.learntube.ai/files/AI_Syllabus_generator/Netflix_-_png_0__1_.png?updatedAt=1685624248825',
    'https://assets.learntube.ai/files/AI_Syllabus_generator/Google_-_png_0__1_.png?updatedAt=1685624248441'
]
export const companyLogo2 = [
    'https://assets.learntube.ai/files/AI_Syllabus_generator/image_340.png?updatedAt=1685624248922',
    'https://assets.learntube.ai/files/AI_Syllabus_generator/image_343.png?updatedAt=1685624509156',
    'https://assets.learntube.ai/files/AI_Syllabus_generator/image_344.png?updatedAt=1685624248932',
    'https://assets.learntube.ai/files/AI_Syllabus_generator/image_345.png?updatedAt=1685624248680',
    'https://assets.learntube.ai/files/AI_Syllabus_generator/Paytm_-_jpeg_0.png?updatedAt=1685624248692'
]

export const companyList1 = [
    'https://assets.learntube.ai/files/About-us/Stripe_-_png_0.png?updatedAt=1689841721147',
    'https://assets.learntube.ai/files/About-us/Netflix_-_png_0.png?updatedAt=1689841784275',
    'https://assets.learntube.ai/files/About-us/Twitter__-_png_0.png?updatedAt=1689841630758',
    'https://assets.learntube.ai/files/About-us/Spotify_-_png_0.png?updatedAt=1689841851007',
    'https://assets.learntube.ai/files/About-us/Expedia_-_png_0.png?updatedAt=1689842162702',
    'https://assets.learntube.ai/files/About-us/Apple_-_png_0.png?updatedAt=1689842084926',
    'https://assets.learntube.ai/files/About-us/Adobe_-_png_0.png?updatedAt=1689841946750',
    'https://assets.learntube.ai/files/About-us/Tata_Consultancy_Services_-_png_0.png?updatedAt=1689842026923',
    'https://assets.learntube.ai/files/About-us/Airbnb_-_png_0.png?updatedAt=1689842238525',
    'https://assets.learntube.ai/files/About-us/Slack_-_png_0.png?updatedAt=1689842318844',
    'https://assets.learntube.ai/files/About-us/Intel_-_png_0.png?updatedAt=1689842367676',
    'https://assets.learntube.ai/files/About-us/Figma_-_png_0.png?updatedAt=1689842408135'
]

const BenefitsSection = () => {
    return (
        <div>
            <div className='p-4 bg-[#2D4F71] rounded-xl'>
                <div className='flex gap-x-6'>
                    <div className='hidden md:block md:w-[50%] h-full flex-1'>
                        <img src="https://assets.learntube.ai/files/Onboarding_Revamp/Group%206770.png?updatedAt=1694519221181" alt="demo certificate" className='w-full h-auto'/>
                    </div>
                    <div className='hidden flex-1 md:block'>
                        <p className='md:text-sm font-semibold'>More Companies Who Recognise This Certificate</p>
                        <div className='w-full grid md:grid-cols-3 gap-3'>
                            {companyList1?.map((item, index) => (
                                <div className='w-4/5 h-full'>
                                    <img key={index} src={item} alt="company images" width={75} height={44} className='w-full h-full'/>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className='grid md:grid-cols-2 gap-3 md:mt-5'>
                    <div className='bg-[#16314C] rounded-xl py-2'>
                        <div className='flex items-center justify-center'>
                            <div className='mr-2'>
                                <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Layer_2.png?updatedAt=1685624731202" alt="spike image" />
                            </div>
                            <p><span className='font-bold text-[#2BBD13]'>74%</span> chance of getting hired by:</p>
                        </div>
                        <div className='flex justify-center items-center mt-2 mb-1'>
                            {companyLogo1.map((item, index) => (
                                <div className='mr-2 w-[30px] h-full' key={index}>
                                    <img src={item} alt="" className='w-full h-auto'/>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className='bg-[#16314C] rounded-xl py-2'>
                        <div className='flex items-center justify-center'>
                            <div className='mr-2'>
                                <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Layer_2.png?updatedAt=1685624731202" alt="spike image"  />
                            </div>
                            <p><span className='font-bold text-[#2BBD13]'>88% </span>chance of getting hired by:</p>
                        </div>
                        <div className='flex justify-center items-center mt-2 mb-1'>
                            {companyLogo2.map((item, index) => (
                                <div className='mr-2 w-[30px] h-full' key={index}>
                                    <img src={item} className='w-full h-auto' alt="company logo" />
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className='bg-[#16314C] rounded-xl py-2 flex flex-col items-center justify-center'>
                        <div className='flex justify-center items-center'>
                            <div className='mr-2'>
                                <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Layer_2.png?updatedAt=1685624731202" alt="spike image"  />
                            </div>
                            <p><span className='font-bold text-[#2BBD13]'>43%</span> higher pay than the average</p>
                        </div>
                        <p className='font-bold'> starting salary</p>
                    </div>
                    <div className='bg-[#16314C] text-center rounded-xl py-2'>
                        <p>Personalised learning is <span className='font-bold text-[#2BBD13]'>98%</span> more effective than normal</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BenefitsSection